import { render, staticRenderFns } from "./EditReferral.vue?vue&type=template&id=41510108"
import script from "./EditReferral.vue?vue&type=script&lang=js"
export * from "./EditReferral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports